import React from 'react';
import { Grid, Paper, Box } from '@mui/material';
import { MapSyncProvider } from './maps/map_syncro.js';
import MapLeft from './maps/map_left.js';
import MapRight from './maps/map_right.js';
import LoginMapRight from '../login/login_mapRight.js';

/**
 * Container component for the performance maps
 * @param {Object} props - Component props
 * @returns {JSX.Element} MapContainer component
 */
const MapContainer = ({
  prettyModelName,
  issueTime,
  cqlSevere,
  cqlFecha,
  mapLeftLayer,
  weekNumber,
  selectedTime,
  isAuthenticatedRight,
  mapRightLayer,
  selectedModel,
  onLogin
}) => {
  return (
    <div className="map-container">
      <Grid container spacing={2}>
        {/* Left Map */}
        <Grid item xs={12} md={6} sx={{ height: '100%', width: '100%' }}>
          <Paper elevation={2} sx={{ padding: 0.25 }}>
            <Box>
              <span className='span_performance'>
                <strong>{prettyModelName}</strong> forecast. ISSUE TIME: <strong>{issueTime} UTC</strong>
              </span>
              <MapSyncProvider>
                <MapLeft 
                  cqlSevere={cqlSevere} 
                  cqlFecha={cqlFecha} 
                  mapLeftLayer={mapLeftLayer} 
                  weekNumber={weekNumber} 
                  issueTime={issueTime} 
                  selectedTime={selectedTime}
                />
              </MapSyncProvider>
            </Box>
          </Paper>
        </Grid>

        {/* Right Map */}
        <Grid item xs={12} md={6} sx={{ height: '100%', width: '100%' }}>
          <Paper elevation={2} sx={{ padding: 0.25, position: 'relative', zIndex: 0 }}>
            <span className='span_performance'>
              Ground truth for VALID TIME: <strong>{cqlFecha} UTC</strong>
            </span>
            
            {isAuthenticatedRight ? (
              // Authenticated: show interactive map
              <MapSyncProvider>
                <MapRight 
                  cqlSevere={cqlSevere} 
                  cqlFecha={cqlFecha} 
                  mapRightLayer={mapRightLayer} 
                  weekNumber={weekNumber} 
                  issueTime={issueTime} 
                  selectedModel={selectedModel} 
                  isInteractive={true}
                  isAuthenticatedRight={isAuthenticatedRight}
                />
              </MapSyncProvider>
            ) : (
              // Not authenticated: show static image
              <Box
                sx={{
                  position: 'relative',
                  width: '100%',
                  height: '45vh',
                  overflow: 'hidden',
                }}
              >
                <img 
                  src="/images/Fondo_mapRight.png" 
                  alt="Static ground truth map" 
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                />
              </Box>
            )}
            
            {/* Login overlay when not authenticated */}
            {!isAuthenticatedRight && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: 'rgba(255, 255, 255, 0.72)',
                  backdropFilter: 'blur(5px)',
                  zIndex: 10,
                }}
              >
                <LoginMapRight onLogin={onLogin} />
              </Box>
            )}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default MapContainer;
